import Vue from "vue";
import filterType from "@/assets/js/filterType";

const filter = {
  namespaced: true,
  state: {
    data: {},
    isClick: false,
    isFilterMode: false,
    isClearFilter: false
  },

  getters: {
    //for public
    getFilter: state => state.data,
    getIsClick: state => state.isClick,
    getIsFilterMode: state => state.isFilterMode,
    getIsClearFilter: state => state.isClearFilter
  },

  actions: {
    actionSetFilter({ commit }, { key, value }) {
      commit("setFilter", { key, value });
    },

    actionSetFilters({ commit, state }, filters) {
      let tempObj = {};
      //if state filters have data
      if (Object.keys(state.data).length > 0) {
        Object.assign(tempObj, state.data);
      }

      let obj = {};
      filters.forEach(filter => {
        if (filter.fieldType == filterType.SelectBox) {
          if (filter.value == 0 || filter.value) {
            obj[filter.id] = filter.value;
          }
        } else if (filter.fieldType == filterType.DateRange) {
          if (filter.from.value || filter.from.value == "") {
            obj[filter.from.id] = filter.from.value;
          }
          if (filter.to.value || filter.from.value == "") {
            obj[filter.to.id] = filter.to.value;
          }
        } else {
          if (filter.value == "" || filter.value) {
            obj[filter.id] = filter.value;
          }
        }
      });
      let newObj = Object.assign(tempObj, obj);
      commit("setFilters", newObj);
    },

    actionResetData({ commit, dispatch, rootGetters }) {
      let allGrid = rootGetters["grid/getGrid"];
      Object.entries(allGrid).forEach(([key, grid]) => {
        dispatch("grid/actionSetFilterItem", {
          gridId: key,
          filterItem: null
        }, {
          root: true
        })
      })

      commit("resetData");
    },
    actionSetIsClearFilter({ commit }, isClearFilter) {
      commit("setIsClearFilter", isClearFilter);

      //reset
      setTimeout(() => {
        commit("setIsClearFilter", false);
      }, 100);
    },
    actionSetFilterMode({ commit }) {
      commit("setFilterMode");
    },
    actionReSetFilterMode({ commit }) {
      commit("resetFilterMode");
    },
    actionDeleteFIlter({ commit }, key) {
      commit("deleteFilter", key);
    },

    actionFindNow({ commit, dispatch, state, rootGetters }, page) {
      return new Promise((resolve, reject) => {

        let allGrid = rootGetters["grid/getGrid"];
        let length = Object.keys(allGrid).length;
        let gridIdArr = [];
        let isMultiple;
        if (length > 1) {
          isMultiple = true;
        } else {
          isMultiple = false;
        }

        let requestArr = [];
        let checkResult = "";

      

        let allGridArr = Object.entries(allGrid);

        allGridArr.forEach(([key, grid]) => {
          //check first
          let filters = grid.requestFilter ? grid.requestFilter : [];
          
            


          filters.forEach(filter => {
            let type = filter.fieldType;
            if (type == filterType.DateRange && filter.isRequired) {

              checkResult = checkDate(
                filter.from.value,
                filter.to.value,
                filter.placeholder
              );

              if (checkResult != "") {
                return;
              }
            }

          });

          if (checkResult != "") {
            return;
          }

        })

        if (checkResult != "") {
          dispatch("message/actionSetMessageStrOnly", checkResult, {
            root: true
          });
          reject();
          return;
        }


        allGridArr.forEach(([key, grid]) => {
          let tempObj = {};
          //if the grid filterItem is exist
          if (grid.filterItem) {
            Object.assign(tempObj, grid.filterItem);
          }
          
          let filters = grid.requestFilter ? grid.requestFilter : [];
          console.log(filters);
          let filterItem = Object.assign(tempObj, resetFilterItem(filters));
          let baseUrl = grid.baseUrl;
          //delete if not value
          delNullValue(filterItem)

          gridIdArr.push(key);
          let obj = {
            page: page,
            gridId: key,
            uri:baseUrl + "/" + key,
            token: JSON.parse(window.localStorage.getItem("ccrs_user"))
              .session_id,
            filterItem: filterItem,
            pageNum: grid.pageNum,
            pageSize: grid.pageSize,
            sum_amount_column: grid.sum_amount_column,
            temp_date_column: grid.temp_date_column
          };
          if (grid.isMainGrid) {
            //if main grid , push first
            requestArr = [obj, ...requestArr];
          } else {
            requestArr.push(obj);
          }
        });
        if (isMultiple) {
          dispatch("grid/actionRequestAll", requestArr, {
            root: true
          })
            .then(r => {
              dispatch(
                "actioSetResponse",
                {
                  isSuccess: true,
                  r: r,
                  id: gridIdArr.join(",")
                },
                {
                  root: true
                }
              );
              resolve(r);
            })
            .catch(err => {
              dispatch(
                "actioSetResponse",
                {
                  isSuccess: false,
                  r: err,
                  id: gridIdArr.join(",")
                },
                {
                  root: true
                }
              );
              reject(err);
            });
        } else {
          if (requestArr.length > 0) {
            dispatch("grid/actionRequest", requestArr[0], {
              root: true
            })
              .then(r => {
                dispatch(
                  "actioSetResponse",
                  {
                    isSuccess: true,
                    r: r,
                    id: gridIdArr.join(",")
                  },
                  {
                    root: true
                  }
                );
                resolve(r);
              })
              .catch(err => {
                dispatch(
                  "actioSetResponse",
                  {
                    isSuccess: false,
                    r: err,
                    id: gridIdArr.join(",")
                  },
                  {
                    root: true
                  }
                );
                reject(err);
              });
          }
        }
        commit("resetFilterMode");
      });
    },

    actionFindNowById(
      { commit, dispatch, state, rootGetters },
      { page, gridId }
    ) {
      return new Promise((resolve, reject) => {
        let grid = rootGetters["grid/getGridById"](gridId);
        let baseUrl = grid.baseUrl;
        //check first
        let filters = grid.requestFilter ? grid.requestFilter : [];
        let isCheckSuccess = true;

        filters.forEach(filter => {
          let type = filter.fieldType;
          if (type == filterType.DateRange && filter.isRequired) {

            let result = checkDate(
              filter.from.value,
              filter.to.value,
              filter.placeholder

            );
            if (result !== "") {
              isCheckSuccess = false;
              dispatch("message/actionSetMessageStrOnly", result, {
                root: true
              });
              return;
            }
          }
        });

        if (!isCheckSuccess) {
          return;
        }

        let tempObj = {};
       
        //if the grid filterItem is exist
        if (grid.filterItem) {
          Object.assign(tempObj, grid.filterItem);
        }

        let filterItem = Object.assign(tempObj, resetFilterItem(filters));

        //delete if not value
        delNullValue(filterItem)
        
        let obj = {
          page: page,
          gridId: gridId,
          uri: baseUrl + "/" + gridId,
          token: JSON.parse(window.localStorage.getItem("ccrs_user"))
            .session_id,
          filterItem: filterItem,
          pageNum: grid.pageNum,
          pageSize: grid.pageSize,
          sum_amount_column: grid.sum_amount_column,
          temp_date_column: grid.temp_date_column
        };
        dispatch("grid/actionRequest", obj, {
          root: true
        })
          .then(r => {
            dispatch(
              "actioSetResponse",
              {
                isSuccess: true,
                r: r,
                id: gridId
              },
              {
                root: true
              }
            );
            resolve(r);
          })
          .catch(err => {
            dispatch(
              "actioSetResponse",
              {
                isSuccess: false,
                r: err,
                id: gridId
              },
              {
                root: true
              }
            );
            reject(err);
          });

        commit("resetFilterMode");
      });
    }
  },
  // mutations
  mutations: {
    setFilter(state, { key, value, selectIndex }) {
      delete state.data[key];

      Vue.set(state.data, key.toUpperCase(), value);
      if (selectIndex) {
        Vue.set(state.data.key, "selectIndex", selectIndex);
      }
      // console.log(state.data[key]);
    },


    setFilters(state, obj) {
      Vue.set(state, "data", obj);
    },
    deleteFilter(state, key) {
      delete state.data[key];

      // console.log(state.data[key]);
    },
    setIsClearFilter(state, isClearFilter) {
      state.isClearFilter = isClearFilter;
      state.data = {};
    },
    resetData(state) {
      state.data = {};
    },
    //find now

    setFilterMode(state) {
      state.isFilterMode = !state.isFilterMode;
    },
    resetFilterMode(state) {
      state.isFilterMode = false;
    }
  }
};

function resetFilterItem(filters) {
  let filterItem = {};

  filters.forEach(filter => {
    let type = filter.fieldType;
    let id = filter.model;
    if (type == filterType.Tags) {
      if (filter.value) {
        filterItem[id] = filter.value.split(",");
      } else {
        filterItem[id] = null;
      }
    } else if (type == filterType.DateRange) {
      filterItem[id] = {
        from: filter.from.value,
        to: filter.to.value
      };
    } else if (type == filterType.SelectBox) {
      if (filter.value || filter.value == "") {
        filterItem[id] = filter.value;
      }
    } else if (type == filterType.Select2) {
      if (filter.value) {
        filterItem[id] = filter.value;
      }
    } else if (type == filterType.AmountRange) {
      if (filter.from.value || filter.to.value) {
        filterItem[id] = {
          from: filter.from.value,
          to: filter.to.value
        };
      }
    } else {
      filterItem[id] = filter.value;
    }
  });

  return _.cloneDeep(filterItem);
}

function checkDate(d1, d2, placeholder) {
  if (!isValidDate(d1) || !isValidDate(d2)) {
    return "Please input valid  " + placeholder;
  }

  if (
    (Date.parse(d1) - Date.parse(d2)) / (1000 * 60 * 60 * 24) > 7 ||
    (Date.parse(d1) - Date.parse(d2)) / (1000 * 60 * 60 * 24) < -1 * 7
  ) {
    return `The ${placeholder} must within 7 days`;
  }

  return "";
}

function delNullValue(obj) {
  //delete if not value
  Object.keys(obj).forEach(key => (obj[key] === null || obj[key] === "") && delete obj[key]);
}

function isValidDate(date) {
  if (date == "" || date == null || date == undefined) {
    return false;
  }

  let d = new Date(date);
  if (isNaN(d)) {
    return false;
  }

  return true;
}

function stringEmptyOrNull(str) {
  if (str == "" || str == null || str == undefined) {
    return true;
  } else {
    return false;
  }
}

export default filter;
